import useText from '@/hooks/useText';

export default function RInstallation() {
  const installationText = useText('rpackage.installation');
  const examplesText = useText('rpackage.examples');

  return (
    <div>
      <p>
        The package disgenet2r is available through GitLab at{' '}
        <a href="https://gitlab.com/medbio/disgenet2r" target="_blank" rel="noopener noreferrer">
          https://gitlab.com/medbio/disgenet2r
        </a>
        . The package requires an R version greater than 3.5.
        <br />
        You can install disgenet2r by typing the following commands in R:
      </p>
      <pre
        style={{
          backgroundColor: '#f6f8fa',
          padding: '10px',
          borderRadius: '5px',
          fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace;',
          whiteSpace: 'pre-wrap',
        }}
      >
        <code>{`library(devtools)
install_gitlab("medbio/disgenet2r")`}</code>
      </pre>
      <div>
        <p>
          {installationText} {' '}
          <a href="https://medbio.gitlab.io/disgenet2r/" target="_blank" rel="noopener noreferrer">
            {examplesText}
          </a>
        </p>
      </div>
    </div>
  );
}
